import { cva as e } from "class-variance-authority";
// src/design/forms/checkbox/style.ts
var t = e("inline-flex items-center gap-2 cursor-pointer group transition-opacity relative", {
	variants: {
		size: {
			xs: "gap-0.25",
			sm: "gap-0.5",
			md: "gap-1",
			lg: "gap-1.5"
		},
		disabled: {
			true: "opacity-90 cursor-not-allowed",
			false: ""
		}
	},
	defaultVariants: {
		size: "md",
		disabled: !1
	}
}), n = e([
	"relative flex items-center justify-center rounded-full transition-colors duration-normal",
	"before:absolute before:inset-0 before:rounded-full before:transition-all before:duration-normal",
	"group-hover:before:bg-muted",
	"disabled:before:bg-transparent"
], {
	variants: { size: {
		xs: "p-1 before:-m-0.5",
		sm: "p-1 before:-m-0.5",
		md: "p-1.5 before:-m-0.5",
		lg: "p-1.5 before:-m-0.5"
	} },
	defaultVariants: { size: "md" }
}), r = e([
	"relative flex items-center justify-center shrink-0",
	"border-2 rounded-md transition-all duration-normal",
	"data-[state=checked]:bg-primary data-[state=checked]:border-primary",
	"data-[state=indeterminate]:bg-primary data-[state=indeterminate]:border-primary",
	"data-[invalid]:border-destructive",
	"data-[disabled]:bg-muted data-[disabled]:cursor-not-allowed data-[disabled]:border-border",
	"hover:border-primary",
	"data-[focus-visible]:border-ring data-[focus-visible]:ring-3 data-[focus-visible]:ring-ring/50"
], {
	variants: {
		size: {
			xs: "h-3 w-3 rounded-sm",
			sm: "h-4 w-4 rounded-sm",
			md: "h-5 w-5",
			lg: "h-6 w-6"
		},
		variant: {
			default: "border-input-border bg-input-background",
			outline: "border-primary bg-transparent",
			soft: "border-secondary bg-secondary"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "default"
	}
}), i = e("font-medium leading-none cursor-pointer select-none transition-colors text-foreground group-hover:text-foreground data-[disabled]:cursor-not-allowed data-[disabled]:text-muted-foreground", {
	variants: { size: {
		xs: "text-xs",
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base"
	} },
	defaultVariants: { size: "md" }
}), a = e("flex items-center justify-center text-primary-foreground", {
	variants: { size: {
		xs: "h-2 w-2",
		sm: "h-3 w-3",
		md: "h-4 w-4",
		lg: "h-5 w-5"
	} },
	defaultVariants: { size: "md" }
}), o = e("flex flex-col", {
	variants: {
		spacing: {
			none: "gap-0",
			xs: "gap-0.5",
			sm: "gap-2",
			md: "gap-3",
			lg: "gap-4"
		},
		orientation: {
			vertical: "flex-col",
			horizontal: "flex-row flex-wrap"
		}
	},
	defaultVariants: {
		spacing: "md",
		orientation: "vertical"
	}
}), s = e("text-sm leading-1 font-medium text-foreground mb-1", { variants: {
	required: {
		true: "after:content-[\"*\"] after:ml-0.5 after:text-destructive",
		false: ""
	},
	disabled: {
		true: "",
		false: ""
	}
} }), c = e("text-sm font-medium text-destructive"), l = e("text-xs text-muted-foreground"), u = (e) => ({
	root: (n) => t({
		size: e?.size,
		disabled: n
	}),
	controlWrapper: () => n({ size: e?.size }),
	control: () => r({
		size: e?.size,
		variant: e?.variant
	}),
	label: () => i({ size: e?.size }),
	indicator: () => a({ size: e?.size }),
	group: () => o({
		spacing: e?.spacing,
		orientation: e?.orientation
	}),
	groupLabel: (e) => s(e),
	errorText: () => c(),
	helperText: () => l()
});
export { r as controlStyles, n as controlWrapperStyles, c as errorTextStyles, u as getStyles, s as groupLabelStyles, o as groupStyles, l as helperTextStyles, a as indicatorStyles, i as labelStyles, t as rootStyles };

//# sourceMappingURL=style.js.map